import { NbRoleProvider } from '@nebular/security';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { TipoOperatore } from './user';
import { UserService } from './services';

@Injectable()
export class RoleProvider extends NbRoleProvider {
  constructor(private userService: UserService) {
    super();
  }

  getRole() {
    switch (this.userService.role) {
      case TipoOperatore.SUPER:
        return of('admin');
      case TipoOperatore.NORMALE:
        return of('operator');
      default:
        return of('guest');
    }
  }
}
